<template lang="pug">
#cookie-agree
  .cookie-intro-container(v-if="showIntro")
    .text-button-container
      .paragraph-text {{__('We use necessary cookies for site functionality and offer optional ones for an enhanced user experience. Choosing "Accept All" enables personalized content. You can manage cookie preferences in "Cookie Settings," which can be adjusted or withdrawn at any time.')}}
        rogue-link.cookie-link(:to="policyLink") {{ __('Learn More') }}
      .button-intro-container
        RogueButton(type="button" color="black" @click="confirmAllCookies" size="small") {{ __('Accept All') }}
        RogueButton(type="button" color="gray" @click="showCookiesSettings" size="small") {{ __('Cookie Settings') }}
  CookiePreferencesSidebar(v-if="overlay === 'cookie-settings'" @close="showIntro = false")
</template>

<script lang="ts" setup>
import { onMounted, computed, ref } from 'vue'
import CookiePreferencesSidebar from './cookie-preferences-sidebar.vue'
import { useCookieManagement } from './useCookieManagement'
import { useUIStore } from '@/js/stores/uiStore'
import { useRogue } from '@/js/services/Rogue'
import { getCookie, setCookie } from '@/js/services/Utils'

const { policyLink, gpcValue, COOKIE_NAME } = useCookieManagement()

const uiStore = useUIStore()
const rogue = useRogue()

const showIntro = ref(false)

const overlay = computed(() => uiStore.overlay)

showIntro.value = false

function showCookiesSettings() {
  uiStore.showOverlay('cookie-settings', rogue)
  showIntro.value = false
}

function confirmAllCookies() {
  setCookie(COOKIE_NAME, JSON.stringify({ marketing: !gpcValue, functional: true, performance: true }))
  
  rogue.track.init(rogue)
  showIntro.value = false
}

onMounted(() => {
  if (!getCookie(COOKIE_NAME)) {
    showIntro.value = true
  }
})
</script>

<style lang="scss" scoped>
  .cookie-intro-container {
    background: $color-white;
    color: $color-black;
    border-radius: $radius-default;
    width: 100%;
    padding: $size-l;
    overflow-y: auto;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9999999;
    border-top: 1px solid $color-black-light;

    @include not-desktop {
      margin-bottom: 0;
      font-size: $size-xs;

    }

    .text-button-container {
      display: flex;
      align-items: center;
      justify-content: center;

      @include not-desktop {
        width: 100%;
        flex-direction: column;
      }

      .paragraph-text {
        margin-bottom: 0;

        .cookie-link {
          margin-left: 5px;
        }
      }

    .button-intro-container {
      display: flex;
      width: 30%;
      justify-content: flex-end;

      @include all-desktop {
        Button {
          margin-right: $size-l;
          margin-left: 15px;
          width: 150px;
        }
      }

      @include not-desktop {
        width: 100%;
        margin-top: $space-m;

        display: flex;
        flex-direction: column;
        gap: $size-xxs;

        Button {
          flex: 1;
        }
      }
    }
  }
}

</style>
<style lang="scss" scoped target="app">
  .platform-ios, .platform-android {
    .button-intro-container button {
      margin-bottom: 0 !important;
    }
  }
</style>
